import * as React from 'react';
import { NoNavigationPageWrapper } from '../../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { PublicPageProvider } from '../_contexts/PublicPageContext';


export function PublicPageWrapper({siteId, children}: React.PropsWithChildren<{siteId?: string}>): JSX.Element {
    
    return (
        <PublicPageProvider siteId={siteId}>
            <NoNavigationPageWrapper>
                {children}
            </NoNavigationPageWrapper>
        </PublicPageProvider>
    );
}


